/**
 * OfflineBanner — persistent banner when offline + toast on transitions
 */
import { useEffect, useRef } from 'react';
import useNetworkStatus from '../../hooks/useNetworkStatus';
import { useToast } from './ToastContext';

const OfflineBanner = () => {
  const { isOnline } = useNetworkStatus();
  const { addToast } = useToast();
  const prevOnline = useRef(isOnline);

  useEffect(() => {
    // Only toast on transitions, not on initial render
    if (prevOnline.current === isOnline) return;

    if (!isOnline) {
      addToast({
        message: "You're offline — your data is saved locally",
        type: 'info',
        duration: 6000,
      });
    } else {
      addToast({
        message: "You're back online!",
        type: 'success',
      });
    }

    prevOnline.current = isOnline;
  }, [isOnline, addToast]);

  if (isOnline) return null;

  return (
    <div className="offline-banner" role="alert">
      You're offline — data is saved locally and will sync when reconnected.
    </div>
  );
};

export default OfflineBanner;
